import { useContext } from "react";

import { ThemeContext } from "../../context";

import darkLogo from "../../assets/images/doggo-dark.png";
import lightLogo from "../../assets/images/doggo-light.png";

export const Logo = () => {
  const { isDarkMode } = useContext(ThemeContext);

  return (
    <div
      className={`uk-panel uk-width-2-3 uk-width-1-3@s uk-padding-small${
        isDarkMode ? " uk-light" : ""
      }`}
    >
      <a className="uk-logo" href="/">
        <img src={lightLogo} alt="" />
        <img className="uk-logo-inverse" src={darkLogo} alt="" />
      </a>
    </div>
  );
};
